export enum EncargoPrevistoRealizado {
  'Previsto' = 'P',
  'Realizado' = 'R'
}
export enum TipoEncargo {
  'EER ' = 'EER',
  'ESS' = 'ESS'
}

export interface Encargo {
  readonly id?: number | null;
  readonly idUsuario?: number | null;
  readonly anoMesReferencia?: string | null;
  readonly volumeEnergiaHora?: number | null;
  readonly tipo?: TipoEncargo | null;
  readonly previstoRealizado?: EncargoPrevistoRealizado | null;
}
